// extracted by mini-css-extract-plugin
export default {"notif":"NotificationHeaderIcon_notif__Dqz-I","badgeCircle":"NotificationHeaderIcon_badgeCircle__k-jXU"};